import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AuthProvider from './context/AuthContext';
import BranchProvider from './context/BranchContext';
import Layout from './components/layout/Layout';
import SsoLogin from './pages/auth/SsoLogin';
import Dashboard from './pages/Dashboard';
import ProductList from './pages/products/ProductList';
import CategoryList from './pages/categories/CategoryList';
import ModelList from './pages/models/ModelList';
import PersonnelList from './pages/personnel/PersonnelList';
import DepartmentList from './pages/departments/DepartmentList';
import CompanyList from './pages/companies/CompanyList';
import RepairManagement from './pages/repairs/RepairManagement';
import InventoryList from './pages/inventory/InventoryList';
import ScrappedList from './pages/scrapped/ScrappedList';
import ScrapApprovalList from './pages/scrap-approvals/ScrapApprovalList';
import ProblematicList from './pages/problematic/ProblematicList';
import ProblematicProducts from './pages/problematic/ProblematicProducts';
import Statistics from './pages/statistics/Statistics';
import CategoryReportPage from './pages/reports/CategoryReportPage';
import BranchReportPage from './pages/reports/BranchReportPage';
import PersonnelReportPage from './pages/reports/PersonnelReportPage';
import CompanyReportPage from './pages/reports/CompanyReportPage';
import ComputerReportPage from './pages/reports/ComputerReportPage';
import NoteList from './pages/notes/NoteList';
import ExpenseList from './pages/expenses/ExpenseList';
import ToolList from './pages/tools/ToolList';
import UserList from './pages/users/UserList';
import BranchList from './pages/branches/BranchList';
import ServiceProviderList from './pages/service-providers/ServiceProviderList';
import BrandList from './pages/brands/BrandList';
import DeviceList from './pages/devices/DeviceList';
import ProtectedRoute from './components/auth/ProtectedRoute';
import ErrorBoundary from './components/common/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BranchProvider>
          <BrowserRouter>
            <Routes>
              {/* Public routes */}
              <Route path="/sso-login" element={<SsoLogin />} />

              {/* Protected routes with layout */}
              <Route element={<ProtectedRoute />}>
                <Route element={<Layout />}>
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  
                  {/* Device Management */}
                  <Route path="/devices" element={<DeviceList />} />
                  <Route path="/products" element={<ProductList />} />
                  <Route path="/categories" element={<CategoryList />} />
                  <Route path="/models" element={<ModelList />} />
                  <Route path="/brands" element={<BrandList />} />
                  
                  {/* Personnel Management */}
                  <Route path="/personnel" element={<PersonnelList />} />
                  <Route path="/departments" element={<DepartmentList />} />
                  <Route path="/companies" element={<CompanyList />} />
                  
                  
                  {/* Inventory Management */}
                  <Route path="/inventory" element={<InventoryList />} />
                  <Route path="/repairs" element={<RepairManagement />} />
                  <Route path="/scrapped" element={<ScrappedList />} />
                  <Route path="/problematic" element={<ProblematicList />} />
                  <Route path="/problematic-products" element={<ProblematicProducts />} />
                  <Route path="/scrap-approvals" element={<ScrapApprovalList />} />
                  
                  {/* Statistics */}
                  <Route path="/statistics" element={<Statistics />} />
                  
                  {/* Reports */}
                  <Route path="/reports/category" element={<CategoryReportPage />} />
                  <Route path="/reports/branch" element={<BranchReportPage />} />
                  <Route path="/reports/personnel" element={<PersonnelReportPage />} />
                  <Route path="/reports/company" element={<CompanyReportPage />} />
                  <Route path="/reports/computer" element={<ComputerReportPage />} />
                  
                  {/* Supporting Modules */}
                  <Route path="/notes" element={<NoteList />} />
                  <Route path="/expenses" element={<ExpenseList />} />
                  <Route path="/tools" element={<ToolList />} />
                  
                  {/* Admin Routes */}
                  <Route path="/users" element={<UserList />} />
                  <Route path="/branches" element={<BranchList />} />
                  <Route path="/service-providers" element={<ServiceProviderList />} />
                </Route>
              </Route>

              {/* Catch all - redirect to sso-login */}
              <Route path="*" element={<Navigate to="/sso-login" replace />} />
            </Routes>
          </BrowserRouter>
        </BranchProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
